import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-translations-extended-text-modal',
    templateUrl: './translations-extended-text-modal.component.html',
    styleUrl: './translations-extended-text-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class TranslationsExtendedTextModalComponent {
  @Input() text: string = '';
  @Input() language: string = '';
  readonly: boolean = environment.environment !== 'Development';

  constructor(public activeModal: NgbActiveModal,) { }

  accept() {
    this.activeModal.close(this.text);
  }
}
